import React, { useEffect, useState } from 'react';
import { Card, Menu, Typography } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';

import Constraints from './constraints';
import DynamicTarget from './dynamic-target';
import StaticTarget from './static-target';
import { ConstraintOperator } from '@/common/ConstraintsEditor/Constraint/facetMap';
import { detectValueItemType } from '@/common/valueItemType';
import {
  getDefaultPopulationTarget,
  getDomain,
  getGeography,
  getRestrictByConstraint,
  isViewMode,
} from '@/features/experiment/constants';
import {
  useExperimentContext,
  useExperimentDispatchContext,
} from '@/features/experiment/contexts/experiment-context';
import {
  setConstraints,
  setSlottingByGroup,
} from '@/features/experiment/store/actions/experiment/action-creators';
import { PopulationTargetMode } from '@/pages/ExperimentFormV2/helper/consts';

const Population = () => {
  const params = useParams<{ action: string }>();
  const action = params.action;
  const readOnly = isViewMode(action);

  const experimentContext = useExperimentContext();
  const experimentDispatch = useExperimentDispatchContext();
  const { experiment } = experimentContext;
  const experimentDomain = experiment?.domain;

  const staticGroup = experiment?.slotting?.byGroup;

  const [populationMode, setPopulationMode] = useState(
    PopulationTargetMode.DYNAMIC,
  );

  useEffect(() => {
    if (staticGroup) setPopulationMode(PopulationTargetMode.STATIC);
  }, [staticGroup, experimentDomain]);

  return (
    <Card
      title={<Typography.Text strong>Population</Typography.Text>}
      styles={{
        body: {
          padding: 16,
        },
      }}
    >
      {!readOnly && (
        <Menu
          selectedKeys={[populationMode]}
          mode="horizontal"
          style={{ padding: 0, margin: '-15px -16px 16px' }}
          items={[
            {
              label: 'Dynamic',
              key: PopulationTargetMode.DYNAMIC,
            },
            {
              label: 'Static',
              key: PopulationTargetMode.STATIC,
            },
          ]}
          onSelect={(item) => {
            setPopulationMode(item.key);

            if (item.key === PopulationTargetMode.STATIC) {
              const constraint = {
                op: ConstraintOperator.EQUALS.value,
                value: '',
                target: getDomain(experiment?.domain)?.targetBy,
              };

              constraint['valueItemType'] = detectValueItemType(constraint);

              experimentDispatch(setSlottingByGroup(constraint));
              experimentDispatch(setConstraints([]));
            } else {
              const experimentDomain = experiment?.domain;
              const geography = getGeography(experimentDomain);
              const restrictByConstraint = getRestrictByConstraint(experiment);
              let constraints = [...(experiment?.constraints || [])];

              if (!restrictByConstraint) {
                constraints.unshift({
                  target: getDefaultPopulationTarget(experiment?.domain),
                  op:
                    geography === 'multi'
                      ? ConstraintOperator.IN.value
                      : ConstraintOperator.EQUALS.value,
                  valueItemType: '',
                  value: '',
                });
              } else {
                restrictByConstraint.op =
                  geography === 'multi'
                    ? ConstraintOperator.IN.value
                    : ConstraintOperator.EQUALS.value;
              }

              experimentDispatch(setSlottingByGroup(undefined));
              experimentDispatch(setConstraints(constraints));
            }
          }}
        />
      )}
      {populationMode === PopulationTargetMode.DYNAMIC && <DynamicTarget />}
      {populationMode === PopulationTargetMode.STATIC && <StaticTarget />}
      <Constraints />
    </Card>
  );
};

export default Population;
